export enum ToastVariant {
  success = 'success',
  error = 'error',
}

export interface CustomToastProps {
  variant: keyof typeof ToastVariant;
  message: string;
}
